import { ProfileModal } from '@/components/modals';

interface ProfileScreenProps {
  onGoHome: () => void;
}

function ProfileScreen({ onGoHome }: ProfileScreenProps) {
  return (
    <ProfileModal
      isOpen={true} // Always open on this screen
      onClose={onGoHome}
    />
  );
}

export default ProfileScreen;